export default {
    default: {
        bg: 'neutral_0',
        borderColor: 'neutral_5',
        '&:focus-within:not(:disabled):not(.disabled), &:focus:not(:disabled):not(.disabled)': {
            borderColor: 'primary_2',
        },
        '&::placeholder, & input::placeholder': {
            color: 'neutral_6',
        },
        '&:hover': {
            borderColor: 'neutral_6',
        },
        '&:invalid, &.invalid': {
            borderColor: 'secondary_2',
        },
        '&:disabled, &.disabled': {
            bg: 'neutral_1',
            color: 'neutral_6',
        },
    },
    search: {
        color: 'neutral_8',
        border: 'none',
        bg: 'transparent',
        '&.active': {
            bg: 'neutral_1',
        },
    },
    inverse: {
        color: 'neutral_0',
        bg: 'primary_2',
        borderColor: 'neutral_5',
        '&:focus-within:not(:disabled):not(.disabled), &:focus:not(:disabled):not(.disabled)': {
            borderColor: 'neutral_0',
        },
        '&::placeholder, & input::placeholder': {
            color: 'neutral_5',
        },
        '&:hover': {
            borderColor: 'neutral_3',
        },
        '&:invalid, &.invalid': {
            borderColor: 'secondary_3',
        },
        '&:disabled, &.disabled': {
            color: 'neutral_5',
        },
    },
};
